export default __webpack_public_path__ + "static/img/all-in-together-transition.911747a.png";